import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wait-route',
  templateUrl: './wait-route.component.html',
  styleUrls: ['./wait-route.component.scss']
})
export class WaitRouteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
